/**
 * RequireNoChurch - Route guard that prevents users who ALREADY have a valid
 * church from visiting onboarding pages like /admin/church-setup and
 * /create-church. Redirects them to /admin/dashboard.
 *
 * Defense-in-depth counterpart to RequireChurch:
 *   - RequireChurch blocks users WITHOUT a church from entering /admin/*.
 *   - RequireNoChurch blocks users WITH a church from re-entering onboarding.
 *
 * Must be used inside ProtectedRoute (user is guaranteed to be non-null).
 */

import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { isEmptyChurchId } from '../utils/churchId';

export const RequireNoChurch: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();

  if (user && !isEmptyChurchId(user.churchId)) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return <>{children}</>;
};
